const selectCurrentDocumentSource = (state) => state.records.currentDocumentSource;

export const selectAutoSplitDocumentSource = (state, recordFileToken) => {
  if (state.records?.fileToken !== recordFileToken) return null;

  return selectCurrentDocumentSource(state) || state.records?.downloadUrl;
};

export default selectCurrentDocumentSource;
